@if (socialMedia() === 'LinkedIn') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span><b>Jane Doe</b></span>
      <br/>
      <span>Chief Engagement Officer at Snöball</span>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span><b>{{title()}}</b></span>
    <br/>
    <span class="facebook-secondary">{{url()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'Twitter') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
      <br/>
      <h6>&#64;janedoe</h6>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span>{{title()}}</span>
    <br/>
    <span class="facebook-secondary mb-2">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'Facebook') {
<div class="card bg-white rounded mx-auto" [style.max-width.px]="imageWidth() ? imageWidth() : 500">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span class="facebook-user">Jane Doe</span>
      <br/>
      <small>Just Now</small>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid w-100"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span class="facebook-secondary">{{url()}}</span>
    <br/>
    <span><b>{{title()}}</b></span>
    <br/>
    <span class="facebook-secondary">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'Whatsapp') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
      <br/>
      <h6>&#64;janedoe</h6>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span>{{title()}}</span>
    <br/>
    <span class="facebook-secondary mb-2">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'Slack') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
      <br/>
      <h6>&#64;janedoe</h6>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span>{{title()}}</span>
    <br/>
    <span class="facebook-secondary mb-2">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'instagram') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2 align-items-center">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
    </div>
      <i class="fa fa-ellipsis-h ms-auto me-1" aria-hidden="true"></i>
  </div>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <strong>Jane Doe</strong> <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
    <br />
    <span class="facebook-secondary mt-2 d-block">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'Email') {
<div class="card bg-white rounded mx-auto p-3 pt-2" style="max-width: 500px;">
  <div>
    <p class="facebook-user m-0">to: example&#64;example.com</p>
    <p class="facebook-user m-0">Subject: {{emailTitle() || title()}}</p>
  </div>
  <hr/>
  <div>
    <p class="pre-wrap">{{emailBody() || message()}}</p>
  </div>
</div>
}

@if (socialMedia() === 'facebook_messenger') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2 align-items-center">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
    </div>
    <i class="fa fa-ellipsis-h ms-auto me-1" aria-hidden="true"></i>
  </div>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <strong>Jane Doe</strong> <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
    <br />
    <span class="facebook-secondary mt-2 d-block">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'microsoft_teams') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2 align-items-center">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
    </div>
    <i class="fa fa-ellipsis-h ms-auto me-1" aria-hidden="true"></i>
  </div>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <strong>Jane Doe</strong> <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
    <br />
    <span class="facebook-secondary mt-2 d-block">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'sms') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2 align-items-center">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
    </div>
    <i class="fa fa-ellipsis-h ms-auto me-1" aria-hidden="true"></i>
  </div>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <strong>Jane Doe</strong> <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
    <br />
    <span class="facebook-secondary mt-2 d-block">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'zalo') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2 align-items-center">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
    </div>
    <i class="fa fa-ellipsis-h ms-auto me-1" aria-hidden="true"></i>
  </div>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <strong>Jane Doe</strong> <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
    <br />
    <span class="facebook-secondary mt-2 d-block">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'line') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2 align-items-center">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
    </div>
    <i class="fa fa-ellipsis-h ms-auto me-1" aria-hidden="true"></i>
  </div>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <strong>Jane Doe</strong> <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
    <br />
    <span class="facebook-secondary mt-2 d-block">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'wechat') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2 align-items-center">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
    </div>
    <i class="fa fa-ellipsis-h ms-auto me-1" aria-hidden="true"></i>
  </div>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <strong>Jane Doe</strong> <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
    <br />
    <span class="facebook-secondary mt-2 d-block">{{description()}}</span>
  </div>
</div>
}

@if (socialMedia() === 'Bluesky') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe <i class='fa fa-certificate twitter-verified'></i></span>
      <br/>
      <h6>&#64;janedoe</h6>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span>{{title()}}</span>
    <br/>
    <span class="facebook-secondary mb-2">{{description()}}</span>
  </div>
</div>
}
@if (socialMedia() === 'Telegram') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe</span>
      <br/>
      <h6>&#64;janedoe</h6>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span>{{title()}}</span>
    <br/>
    <span class="facebook-secondary mb-2">{{description()}}</span>
  </div>
</div>
}
@if (socialMedia() === 'VK') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe</span>
      <br/>
      <h6>&#64;janedoe</h6>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span>{{title()}}</span>
    <br/>
    <span class="facebook-secondary mb-2">{{description()}}</span>
  </div>
</div>
}
@if (socialMedia() === 'Viber') {
<div class="card bg-white rounded mx-auto" style="max-width: 500px;">
  <div class="d-flex mb-2 p-2">
    <img class="img-fluid profile-pic" src="../../../../assets/images/avatars/avatar7.jpg"/>
    <div class="ps-2">
      <span>Jane Doe</span>
      <br/>
      <h6>&#64;janedoe</h6>
    </div>
  </div>
  <span class="ps-2 pe-2 mb-2 pre-wrap">{{message()}}</span>
  @if (contentType() === 'image') {
  <img class="img-fluid w-100" src="{{getImage()}}"/>
  }
  @if (contentType() === 'video') {
  <video
         class="img-fluid rounded me-3 shadow-sm"
         src="{{getImage()}}" width="100%" controls></video>
  }
  <div class="mb-2 p-2">
    <span>{{title()}}</span>
    <br/>
    <span class="facebook-secondary mb-2">{{description()}}</span>
  </div>
</div>
}

